module.exports = __webpack_public_path__ + "img/level_01.51d7d639.svg";